import { Box, Button, Grid, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'


const ContactForm = () => {
    const { t } = useTranslation();
    return (
        <Box
            sx={{
                margin: 0,
                padding: '20px 0',
            }}
        >
            <form autoComplete='off'>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            label={t('forms.name')}
                            name="name"
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: '#ffffff20',
                                        borderRadius: 0,
                                        border: '2px solid rgba(255, 255, 255, 0.2)'
                                    },
                                    '&:hover fieldset': {
                                        borderColor: '#ffffff20',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#ff8303',
                                    },
                                    '& input': {
                                        color: '#ffffff',
                                        fontFamily: 'Poppins, sans-serif',
                                    },
                                },
                                '& label': {
                                    color: '#ffffff70',
                                    fontFamily: 'Poppins, sans-serif',
                                    textTransform: 'uppercase',
                                    '&.Mui-focused': {
                                        color: '#ff8303',
                                    },
                                }
                            }}
                            required
                        />


                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            label={t('forms.email')}
                            name="email"
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: '#ffffff20',
                                        borderRadius: 0,
                                        border: '2px solid rgba(255, 255, 255, 0.2)'
                                    },
                                    '&:hover fieldset': {
                                        borderColor: '#ffffff20',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#ff8303',
                                    },
                                    '& input': {
                                        color: '#ffffff',
                                        fontFamily: 'Poppins, sans-serif',
                                    },

                                },
                                '& label': {
                                    color: '#ffffff70',
                                    fontFamily: 'Poppins, sans-serif',
                                    textTransform: 'uppercase',
                                    '&.Mui-focused': {
                                        color: '#ff8303',
                                    },
                                }
                            }}
                            required
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            label={t('forms.subject')}
                            name="subject"
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: '#ffffff20',
                                        borderRadius: 0,
                                        border: '2px solid rgba(255, 255, 255, 0.2)'
                                    },
                                    '&:hover fieldset': {
                                        borderColor: '#ffffff20',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#ff8303',
                                    },
                                    '& input': {
                                        color: '#ffffff',
                                        fontFamily: 'Poppins, sans-serif',
                                    },

                                },
                                '& label': {
                                    color: '#ffffff70',
                                    fontFamily: 'Poppins, sans-serif',
                                    textTransform: 'uppercase',
                                    '&.Mui-focused': {
                                        color: '#ff8303',
                                    },
                                }
                            }}
                            required
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            multiline
                            rows={10}
                            variant="outlined"
                            label={t('forms.message')}
                            name="message"
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: '#ffffff20',
                                        borderRadius: 0,
                                        border: '2px solid rgba(255, 255, 255, 0.2)'
                                    },
                                    '&:hover fieldset': {
                                        borderColor: '#ffffff20',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#ff8303',
                                    },
                                    '& input': {
                                        color: '#ffffff',
                                    },

                                },
                                '& label': {
                                    color: '#ffffff70',
                                    fontFamily: 'Poppins, sans-serif',
                                    textTransform: 'uppercase',
                                    '&.Mui-focused': {
                                        color: '#ff8303',
                                    },
                                }
                            }}
                            required
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Button
                            variant="contained"
                            color="primary"
                            type='submit'
                            sx={{
                                backgroundColor: '#ff8303',
                                borderRadius: '8px',
                                padding: '12px 24px',
                                color: '#ffffff',
                                fontSize: '16px',
                                fontWeight: 'bold',
                                '&:hover': {
                                    background: '#ff8303',
                                },
                                '@media screen and (max-width: 680px)': {
                                    width: '100%'
                                }
                            }}
                        >
                            {t('forms.send')}
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Box>
    )
}

export default ContactForm